import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-group-icon',
    templateUrl: './group-icon.component.html',
    styleUrls: ['./group-icon.component.scss']
})
export class GroupIconComponent {
    @Input() color = 'inherit';
    @Input() icon = 'icons/fontawesome/solid:flask';
    @Input() icon2 = 'icons/fontawesome/solid:flask';
}
